import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, validate, containsUrl, normalizeUrl, GlobalContext } from 'wix-rich-content-common';
import pluginHtmlSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-html.schema.json';
import { INIT_HEIGHT, INIT_WIDTH, SRC_TYPE_HTML, SRC_TYPE_URL } from './defaults.js';
export { defaults } from './defaults.js';
import IframeHtml from './IframeHtml.js';
import IframeUrl from './IframeUrl.js';
import { h as htmlComponentStyles } from './HtmlComponent-eb256993.js';
import { htmlFixer } from './htmlFixer.js';
import './htmlIframeSrc.js';
import './Iframe.js';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const getPageURL = (siteDomain) => {
  if (!siteDomain) {
    return;
  }
  const regex = /http.+com/gm;
  const res = regex.exec(siteDomain);
  if (res) {
    return res[0];
  }
  return res;
};
class HtmlComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      siteDomain: void 0
    });
    __publicField(this, "setHeight", (iframeHeight) => {
      var _a;
      if (iframeHeight > 0 && iframeHeight !== this.state.iframeHeight) {
        this.setState({ iframeHeight });
        (_a = this.props.store) == null ? void 0 : _a.update("componentData", { config: { height: iframeHeight } });
      }
    });
    __publicField(this, "getIframeHeight", () => {
      const {
        settings: { height } = {},
        componentData: { config }
      } = this.props;
      const { iframeHeight } = this.state;
      const maxDiff = Math.min(50, this.state.iframeHeight * 0.1);
      let normalizedHeight = iframeHeight;
      if (config.height) {
        normalizedHeight = iframeHeight && config.height < iframeHeight && config.height + maxDiff > iframeHeight ? iframeHeight : config.height;
      }
      return normalizedHeight || height || INIT_HEIGHT;
    });
  }
  componentDidMount() {
    const {
      componentData: { config },
      settings = {}
    } = this.props;
    const { width, height, siteDomain } = settings;
    if (!config.width) {
      if (width) {
        config.width = width;
      } else if (this.element) {
        config.width = this.element.getBoundingClientRect().width;
      } else {
        config.width = INIT_WIDTH;
      }
    }
    if (!config.height) {
      config.height = height || INIT_HEIGHT;
    }
    this.setState({ siteDomain });
  }
  static getDerivedStateFromProps(props, state) {
    const { componentData } = props;
    if (componentData.srcType === "html") {
      const pageURL = getPageURL(state.siteDomain);
      return {
        html: htmlFixer(componentData.src, pageURL)
      };
    }
  }
  render() {
    var _a;
    const { html } = this.state;
    const {
      iframeSandboxDomain,
      theme,
      componentData,
      settings: { width } = {},
      isViewer
    } = this.props;
    this.styles = this.styles || mergeStyles({ styles: htmlComponentStyles, theme });
    validate(componentData, pluginHtmlSchema);
    const { src, srcType, config: { width: currentWidth } = {} } = componentData;
    const style = {
      width: this.props.isMobile ? "auto" : currentWidth || width || INIT_WIDTH,
      height: this.getIframeHeight(),
      maxHeight: this.state.iframeHeight
    };
    const experiments = this.props.experiments || this.context.experiments;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: this.styles.htmlComponent,
        ref: (ref) => this.element = ref,
        style,
        "data-hook": "HtmlComponent"
      },
      srcType === SRC_TYPE_HTML && src && /* @__PURE__ */ React.createElement(
        IframeHtml,
        {
          iframeSandboxDomain: iframeSandboxDomain || ((_a = experiments.forceIframeSandboxDomain) == null ? void 0 : _a.enabled) && "https://www.filesusr.com",
          key: SRC_TYPE_HTML,
          tabIndex: 0,
          html,
          onHeightChange: this.setHeight,
          isViewer
        }
      ),
      srcType === SRC_TYPE_URL && containsUrl(src) && /* @__PURE__ */ React.createElement(IframeUrl, { key: SRC_TYPE_URL, tabIndex: 0, src: normalizeUrl(src), isViewer }),
      !src && !containsUrl(src) && /* @__PURE__ */ React.createElement("div", { className: this.styles.htmlComponent_placeholder })
    );
  }
}
__publicField(HtmlComponent, "contextType", GlobalContext);
HtmlComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  blockProps: PropTypes.object,
  className: PropTypes.string,
  settings: PropTypes.shape({
    width: PropTypes.number,
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number,
    height: PropTypes.number,
    minHeight: PropTypes.number,
    maxHeight: PropTypes.number
  }).isRequired,
  store: PropTypes.object,
  block: PropTypes.object,
  siteDomain: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  iframeSandboxDomain: PropTypes.string,
  experiments: PropTypes.object,
  isViewer: PropTypes.bool
};

export { HtmlComponent as Component, HtmlComponent as default };
//# sourceMappingURL=HtmlComponent.js.map
